/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Panel_SampleInputs */

const cs_builder_panel_sample = /** @type {(inputs: Builder_Panel_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukázková data`)
};

const en_builder_panel_sample = /** @type {(inputs: Builder_Panel_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample data`)
};

/**
* | output |
* | --- |
* | "Sample data" |
*
* @param {Builder_Panel_SampleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_panel_sample = /** @type {((inputs?: Builder_Panel_SampleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Panel_SampleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_panel_sample(inputs)
	return cs_builder_panel_sample(inputs)
});